import { useEffect } from "react";
import { PricingSection } from "@/components/landing/PricingSection";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/components/ui/use-toast";
import { supabase } from "@/integrations/supabase/client";

export default function Pricing() {
  const navigate = useNavigate();
  const { toast } = useToast();

  useEffect(() => {
    const checkAuth = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        toast({
          title: "Authentication required",
          description: "Please sign in to access subscription options.",
          variant: "destructive",
        });
        navigate("/auth");
      }
    };

    checkAuth();
  }, [navigate, toast]);

  return (
    <div className="min-h-screen bg-background animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="container mx-auto px-4 pt-20">
        <div className="flex flex-col items-center gap-6">
          <h1 className="text-4xl md:text-5xl font-bold text-center">
            Choose Your Perfect Plan
          </h1>
          <p className="text-lg text-muted-foreground text-center max-w-2xl">
            Unlock the full potential of MindTube with our flexible subscription options.
            Choose the plan that best fits your needs.
          </p>
        </div>
        <PricingSection standalone={true} />
      </div>
    </div>
  );
}